import { useEffect, useState } from 'react'
import { api } from '../../servizi/api.ts'
import { Attesa, Vuoto } from '../../componenti/Pezzi.tsx'
import { Etichetta, Paginazione, Riquadro, Tabella, totaleDi } from '../../componenti/base.tsx'

type VoceCronologia = {
  id: string; avvenuto_il: string; azione: string; descrizione: string
  esito: string; nome: string | null; cognome: string | null
  /** Evento di una scheda unita a questa (473): il suo numero. */
  scheda_unita?: number | string | null
  /** `count(*) over ()` della stessa query: eventi della scheda prima della finestra. */
  totale?: string | number
}

/** Eventi per pagina. La cronologia di una scheda seguita da anni conta migliaia di righe. */
const LIMITE_CRONOLOGIA = 50

export function Cronologia({ personaId }: { personaId: string }) {
  const [eventi, setEventi] = useState<VoceCronologia[] | null>(null)
  const [salta, setSalta] = useState(0)
  const [totaleNoto, setTotaleNoto] = useState<number | null>(null)

  // La scheda cambia: la finestra riparte da capo e il totale precedente non vale piu'.
  const [personaInUso, setPersonaInUso] = useState(personaId)
  if (personaId !== personaInUso) {
    setPersonaInUso(personaId)
    setSalta(0)
    setTotaleNoto(null)
  }

  useEffect(() => {
    let vivo = true
    setEventi(null)
    api.get<VoceCronologia[]>(
      `/persone/${personaId}/cronologia?limite=${LIMITE_CRONOLOGIA}&salta=${salta}`)
      .then((righe) => {
        if (!vivo) return
        setEventi(righe)
        const letto = totaleDi(righe)
        if (letto !== null) setTotaleNoto(letto)
      })
      .catch(() => { if (vivo) setEventi([]) })
    return () => { vivo = false }
  }, [personaId, salta])

  if (!eventi) return <Attesa testo="Caricamento…" />

  return (
    <Riquadro denso>
      <Tabella intestazioni={['Quando', 'Cosa', 'Chi', 'Esito']}
               vuoto={<Vuoto testo="Nessun evento registrato." />}>
        {eventi.map((e) => (
          <tr key={e.id}>
            <td data-etichetta="Quando">{new Date(e.avvenuto_il).toLocaleString('it-IT')}</td>
            <td data-etichetta="Cosa">
              {e.descrizione}
              {e.scheda_unita != null && <span className="tenue piccolo"> · scheda unita n. {e.scheda_unita}</span>}
            </td>
            <td data-etichetta="Chi">{e.nome ? `${e.nome} ${e.cognome}` : 'sistema'}</td>
            <td data-etichetta="Esito">
              <Etichetta tono={e.esito === 'ok' ? 'positivo' : 'critico'}>{e.esito}</Etichetta>
            </td>
          </tr>
        ))}
      </Tabella>
      <Paginazione salta={salta} limite={LIMITE_CRONOLOGIA}
                   totale={totaleDi(eventi) ?? totaleNoto}
                   ricevute={eventi.length} cambia={setSalta} />
    </Riquadro>
  )
}
